// @flow
import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';

type Props = {
    open: boolean,
    handleClose: () => any
};

export default function SubscriptionPlanError({ open, handleClose }: Props) {
    return (
        <div>
            <Dialog data-testid="dialog" open={open} onClose={handleClose}>
                <DialogTitle>
                    There was an error loading your current subscription plan.
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please try again later, we are currently not able to
                        process your request.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button data-testid="dialog-button" onClick={handleClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
